import React from 'react';
import type { FC } from 'react';
import { match, constant } from 'variant';
import type { PlatformsType } from '@wix/cli-app-installer';
import { Box, Link, PointerSmallIcon } from '@wix/cli-ui-kit';

interface PlatformLinkProps {
  url: string;
  platform: PlatformsType;
}

export const PlatformLink: FC<PlatformLinkProps> = ({ url, platform }) => {
  const label = match(platform, {
    editor: constant('Editor'),
    dashboard: constant('Dashboard'),
    site: constant('Site'),
  });

  return (
    <Box marginRight={1}>
      <PointerSmallIcon />
      <Box marginLeft={1}>
        <Link url={url}>{label}</Link>
      </Box>
    </Box>
  );
};
